import isMobile from 'ismobilejs';
import Registry from '../registry/index';
import {closeNotificationsWindow} from "../actions/notifications";
import {BobTVUser} from "../components/bobtv-neo/BobTVUser";
import PmDisabledPopup from "../components/bobtv-neo/PmDisabledPopup";

import {
    PM_MESSAGE,
    PM_SESSION_START,
    PM_SESSION_ACCEPTED,
    PM_WINDOW_MAXIMIZE,
    PM_CONVERSATIONS,
    PM_SESSION_HIDE
} from '../constants/pm';

import {PRIVATE_TOKEN_NOTIFICATION, GET_MEMBER_NOTIFICATIONS_LIST, INSTANT_NOTIFICATION} from "../constants/notifications";

const pmSessionsMiddleware = (store) => (next) => (action) => {
    const config = Registry.get('pmConfig');
    const url = config.url;
    const chatroom_name = config.chatroom_name;
    let wss_url = url.match(/^wss:/) ? url : Registry.get('PUBLIC_URL').replace(/^https?:/, "wss:") + url;
    
    switch(action.type) {
        case "LOGIN_SUCCESS": {
            let currentUserUid = action.user.uid;
            action.user.id = currentUserUid;
            if (!action.user.pm_enabled) break;

            store.dispatch({
                type: "PM_CONNECT_TO_SERVER",
                url: wss_url,
                chatroom_name: chatroom_name,
                user: action.user});

            break;
        }
        case "LOGOUT_SUCCESS":
            store.dispatch({type: "PM_DISCONNECT_FROM_SERVER"});
            break;

        case "ROOM_CLIENT_UPDATE":
            let currentUser = store.getState().currentUser;
            if (action.user.uid == currentUser.uid) {
                if (action.user.pm_enabled && !(currentUser.pm_enabled)) {
                    action.user.id = action.user.uid;
                    store.dispatch({
                            type: "PM_CONNECT_TO_SERVER",
                            url: wss_url,
                            chatroom_name: chatroom_name,
                            user: action.user});
                } else if (!action.user.pm_enabled && (currentUser.pm_enabled)) {
                    store.dispatch({type: "PM_DISCONNECT_FROM_SERVER"});
                }
            }
            break;

        case "PM_SESSION_START":
            currentUser = store.getState().currentUser;
            if (!currentUser.pm_enabled) {
                PmDisabledPopup.open({currentUser});
                return;
            }
            break;

        case "PM_MESSAGE":
            let pmConversation = store.getState().pm.conversations[action.conversation_uid];
            let visibility = store.getState().visibility.visibilityState;
            if (visibility == "visible" && pmConversation.view.maximized) {
                store.dispatch({type: "PM_MARK_READ", conversation_uid: action.conversation_uid});
            }
            break;
        case "VISIBILITY_STATE_CHANGE":
            if (action.visibilityState == "visible") {
                let pm = store.getState().pm;
                if (pm.status == "connected") {
                    for (let i in pm.conversations) {
                        if (pm.conversations[i].view.maximized) {
                            store.dispatch({type:"PM_MARK_READ", conversation_uid: pm.conversations[i].user.uid});
                        }
                    }
                }
            }
            break;
            
        case "PM_UNBLOCK_USER":
            let siteInterface = Registry.get('siteInterface');
            siteInterface.unblock(action.conversation.user);
            break;
        case "PM_OPEN_ATTACHMENT":
            return;
        case "PM_SESSION_DECLINED":
            store.dispatch({type: "PM_ACTION_REVOKE_PERMISSION", conversation: {user:{uid: action.uid}}});
            break;
    }

    if (action.type === GET_MEMBER_NOTIFICATIONS_LIST) {
        action.data.list.forEach(item => {
            if (item.type === 'tip_private_received') {
                let state = store.getState();
                const {data: {meta: {user: {nick}}}} = item;
                let user = state.users.get({nick});
                if (!user) {
                    user = new BobTVUser({
                        ...item.data.meta.user,
                        uid: item.data.meta.user.id
                    });
                }
                item.data.meta.user = user;
            }
        })
    }
    
    if (action.type === INSTANT_NOTIFICATION) {
        const state = store.getState();
        let user = state.users.get({nick: action.data.data.meta.user.nick})
        if (!user) {
            user = new BobTVUser({
                ...action.data.data.meta.user,
                uid: action.data.data.meta.user.id
            });
        }
        action.data.data.meta.user = user;
    }

    if (isMobile.any && action.type === "VISIBLE_ROOM_SWITCHED") {
        store.dispatch({
            type: "PM_WINDOW_MINIMIZE_ALL",
            close_unread: false
        })
    }

    if (isMobile.any && (action.type === PM_SESSION_START || action.type === PM_WINDOW_MAXIMIZE)) {
        store.dispatch(closeNotificationsWindow())
    }

    next(action);
};

export default pmSessionsMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/pmSessions.js